import {
  CLEAR_SEARCH_RESULTS,
  CREATE_TRACK,
  DELETE_TRACK,
  FETCH_TRACKS,
  SEARCH_ERROR,
  SEARCH_SUCCESS,
  TRACK_ERROR,
  UPDATE_TRACK,
} from "../actions/types";

const initialState = {
  tracks: [],
  trackError: null,
  searchResult: null,
  searchError: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case TRACK_ERROR:
      return {
        ...state,
        trackError: action.payload,
      };
    case CREATE_TRACK:
      return {
        ...state,
        track: action.payload,
      };
    case UPDATE_TRACK:
      return {
        ...state,
        track: action.payload,
      };
    case DELETE_TRACK:
      return {
        ...state,
        track: action.payload,
      };
    case FETCH_TRACKS:
      return {
        ...state,
        tracks: action.payload.data && Array.isArray(action.payload.data) ? action.payload.data : [],
        pagination: action.payload.pagination || { current: 1, pageSize: 10, total: 0 },
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        searchResult: action.payload,
      };
    case SEARCH_ERROR:
      return {
        ...state,
        searchError: action.payload,
      };
    case CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchResult: null,
      };
    default:
      return state;
  }
}
